<template>
  <div v-if="svgSrc" v-html="svgSrc" class="c-inline-svg"></div>
</template>

<script>
export default {
  name: 'inline-svg',

  props: {
    name: String,
  },

  computed: {
    svgSrc() {
      const image = require(`@/svg/${this.name}.svg`);
      return image;
    },
  },
};
</script>

<style lang="scss">
.c-inline-svg {
  margin: 2em 0;

  svg {
    fill: none;
  }
}
</style>
